import { map } from 'lodash';
import { errorHandler } from 'utils/errorHandler';


const LOAD = 'server-sts/fiches/LOAD';
const LOAD_SUCCESS = 'server-sts/fiches/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/fiches/LOAD_FAIL';
const EDIT_START = 'server-sts/fiches/EDIT_START';
const EDIT_STOP = 'server-sts/fiches/EDIT_STOP';
const SAVE = 'server-sts/fiches/SAVE';
const SAVE_SUCCESS = 'server-sts/fiches/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/fiches/SAVE_FAIL';
const CREATE = 'server-sts/fiches/CREATE';
const CREATE_SUCCESS = 'server-sts/fiches/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/fiches/CREATE_FAIL';


const CHECK_IDPTU_EXISTS = 'server-sts/fiches/CHECK_IDPTU_EXISTS';
const CHECK_IDPTU_EXISTS_SUCCESS = 'server-sts/fiches/CHECK_IDPTU_EXISTS_SUCCESS';
const CHECK_IDPTU_EXISTS_FAIL = 'server-sts/fiches/CHECK_IDPTU_EXISTS_FAIL';


const DELETE = 'server-sts/fiches/DELETE';
const DELETE_SUCCESS = 'server-sts/fiches/DELETE_SUCCESS';
const DELETE_FAIL = 'server-sts/fiches/DELETE_FAIL';

const CLEAR_FICHES = 'server-sts/fiches/CLEAR_FICHES';

const CANCEL_EDIT = 'server-sts/fiches/CANCEL_EDIT';

const RESET_FORM = 'server-sts/fiches/RESET_FORM';

const LOAD_FICHE = 'server-sts/fiches/LOAD_FICHE';
const LOAD_FICHE_SUCCESS = 'server-sts/fiches/LOAD_FICHE_SUCCESS';
const LOAD_FICHE_FAIL = 'server-sts/fiches/LOAD_FICHE_FAIL';


import { analyseState } from 'utils/analyseState';


const initialState = {
  loaded: false,
  loading: false,
  created: false,
  ficheCreatedError: false,
  editing: {},
  saveError: false,
  success: false,
  currentPage: 1,
  error: false,
  currentProducts: [],
  success: false,
  data: [],
  dashboardOptions: {
    openProducts: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} },
    openPannes: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} },
    openDisactivated: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} },
    openTravaux: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} },
    openUsagers: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} },
    openCyclical: { open: false, query: {}, pagination: { page: 1, perPage: 10 }, sortingColumns: {} }
  },

  lastActivityOptions: {
    'panne': { open: false, query: {}, pagination: { page: 1, perPage: 5 }, sortingColumns: {} },
    'indisponible': { open: false, query: {}, pagination: { page: 1, perPage: 5 }, sortingColumns: {} },
    'usager': { open: false, query: {}, pagination: { page: 1, perPage: 5 }, sortingColumns: {} },

  }
};


export default function reducer(state = initialState, action = {}) {

  

  switch (action.type) {



    case 'SET_DASHBOARD_OPTIONS':

      //
      /*
      options = 
    
      if( 'options' in actions ) {
        options = actions.options
      }*/


      return {
        ...state,

        dashboardOptions: {
          ...state.dashboardOptions,
          [action.panel]: {
            ...state.dashboardOptions[action.panel],
            open: action.open,
            ...action.options,
          }

        }

      };


    case 'SET_LAST_ACTIVITY_OPTIONS':
      return {
        ...state,

        lastActivityOptions: {
          ...state.lastActivityOptions,
          [action.panel]: {
            ...state.lastActivityOptions[action.panel],
            open: action.open,
            ...action.options,
          }

        }

      };

    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result.fiches,
        currentPage: action.result.currentPage,
        fichesNb: action.result.fichesNb,
        pages: action.result.pages,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };


    case LOAD_FICHE:
      return {
        ...state,
        loading: true
      };
    case LOAD_FICHE_SUCCESS:
      
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        fiche: action.result
      };
    case LOAD_FICHE_FAIL:

      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };

    case CANCEL_EDIT:
      return {
        ...state,
        editing: {},
      };

    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        success: false,
        saveError: false
      };

    case CREATE:
      return {
        ...state,
        loading: true
      };

    case CREATE_SUCCESS:
      return {
        ...state,
        data: action.result.fiches,
        currentPage: action.result.currentPage,
        fichesNb: action.result.fichesNb,
        pages: action.result.pages,
        created: true,
        success: action.result,
        loading: false,
        error: false,
      };

    case CREATE_FAIL:
      return {
        ...state,
        success: false,
        created: false,
        loading: false,
        error: errorHandler(action.error.code),
      };

    case DELETE:
      return {
        ...state,
        loading: true
      };

    case DELETE_SUCCESS:
      return {
        ...state,
        data: action.result.fiches,
        currentPage: action.result.currentPage,
        fichesNb: action.result.fichesNb,
        pages: action.result.pages,
        created: true,
        loading: false,
        ficheCreatedError: false,
      };

    case DELETE_FAIL:
      return {
        ...state,
        created: false,
        loading: false,
        ficheCreatedError: action.error,
      };


    case CLEAR_FICHES:
      return {
        ...state,
        data: [],
        loaded: false
      };


    case SAVE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_SUCCESS:
      return {
        ...state,
        success: action.result,
        error: false
      };
    case SAVE_FAIL:
      return {
        ...state,
        error: errorHandler(action.error.code),
        success: false
      };

    case CHECK_IDPTU_EXISTS:
      return state;

    case CHECK_IDPTU_EXISTS_SUCCESS:
      return {
        ...state

      };

    case CHECK_IDPTU_EXISTS_FAIL:
      return {
        ...state
      };

    case RESET_FORM:
      return state;



    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.fiches && globalState.fiches.loaded;
}


export function createFiche(values, params) {

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (fiche) => fiche.post('/fiche/create', {
      data: {
        values,
        params
      }
    })
  };
}

export function load(page, params) {
  var data = params ? { page, params } : { page };
  return {
    promise: (fiche) => fiche.post('/fiche/load', { data: data }),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

  };
}


export function loadFiche(ficheID, params) {
  var data = params ? { ficheID, params } : { ficheID };
  return {
    promise: (fiche) => fiche.post('/fiche/loadFiche', { data: data }),
    types: [LOAD_FICHE, LOAD_FICHE_SUCCESS, LOAD_FICHE_FAIL],

  };
}


export function loadFicheProducts(ficheId, params) {
  var data = params ? { ficheId, params } : { ficheId };
  return {
    promise: (fiche) => fiche.post('/fiche/loadFicheProducts', { data: data }),
    types: [LOAD_FICHE_PRODUCTS, LOAD_FICHE_PRODUCTS_SUCCESS, LOAD_FICHE_PRODUCTS_FAIL],

  };
}

export function resetForm() {
  return { type: RESET_FORM };
}


export function checkIDPTUExists(id, params) {
  
  return {
    promise: (fiche) => fiche.post('/fiche/checkIDPTUExists', { data: { id, params } }),
    types: [CHECK_IDPTU_EXISTS, CHECK_IDPTU_EXISTS_SUCCESS, CHECK_IDPTU_EXISTS_FAIL],
  };
}



export function save(values, fields, params, pristineValues) {

	/*
	var params = params ? {id:params.id} : {};
	if(values.localisation_adresse != null ) {
		if( typeof values.localisation_adresse === 'object') {
			values.localisation_adresse = values.localisation_adresse.label;
		}
	}*/

  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (fiche) => fiche.post('/fiche/update', {
      data: { values, fields, params, pristineValues }
    })
  };
}



export function deleteFiche(fiche, params) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (fiche) => fiche.post('/fiche/deleteFiche', {
      data: { fiche, params }
    })
  };
}

export function setDashboardOptions(panel, open, options = {}) {
  return { type: 'SET_DASHBOARD_OPTIONS', panel, open, options };
}


export function setLastActivityOptions(panel, open, options = {}) {
  return { type: 'SET_LAST_ACTIVITY_OPTIONS', panel, open, options };
}




export function checkFtpActivation() {

}


export function openProductsListPan() {
  return { type: PRODUCTS_LIST_PAN_OPEN };
}


export function clearFiches() {
  
  return { type: CLEAR_FICHES };
}


export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function cancelEdit() {
  return { type: CANCEL_EDIT };
}

